<script>
    import f9button from "inputs/f9button.vue";
    import { initializeCarousel } from "inputs/f9carousel.vue";
    import { forceTabBehavior } from "shared/focusRing";
    import sticky from "vue-sticky-directive";
    import { dispatchWindowEvent, attach } from "shared/eventBus";
    
    let defaultVisibleClass = "slider-visible",
        bodySliderOpenClass = "slider-open",
        defaultPixelWidth = 775,
        focusableSelector = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";

    export default {
        props: {
            title: String,
            subTitle: String,
            value: Boolean,
            padding: {
                type: String | Number,
                default: 40
            },
            pixelWidth: {
                type: Number,
                default: defaultPixelWidth
            },
            preventOutsideFocus: {
                type: Boolean,
                default: true
            },
            returnFocus: {
                type: Boolean,
                default: true
            },
            closeButton: {
                type: Boolean,
                default: true
            },
            canClose: {
                type: Boolean,
                default: true
            },
            modalOpacity: {
                type: Number,
                default: .5
            },
            headerColor: {
                type: String,
                default: ""
            },
            top: {
                type: Number,
                default: 0
            },
            bottom: {
                type: Number,
                default: 0
            },
            side: {
                type: String,
                default: "right",
                validator: value => ["left", "right"].indexOf(value) !== -1
            },
            headerImgSrc:{
                type:String,
                default:""
            },
            isVerticalAlignment: {
                type: Boolean,
                default: false
            },
            applyDDUpsellCustomStyle: {
                type: Boolean,
                default: false
            }
        },
        components: {
            f9button
        },
        data () {
            return {
                visible: false,
                transitioning: false,
                id: null,
                offset: defaultPixelWidth * -1,
                isMounted: false,
                zIndex: 1001,
                allowClose: true,
                stickyInterval: -1,
                scrollToElement: null,
                goToPassEditOnClose: false,
                executeOnMount: () => {}
            };
        },
        mounted () {
            document.body.appendChild(this.$el);
            this.id = this._uid;
            this.offset = this.pixelWidth * -1;
            this.isMounted = true;
            this.zIndex += this.id;
            this.allowClose = this.canClose;
            this.visible = this.value;

            if(this.visible) {
                this.$nextTick(() => this.show());
            }

            this.$refs.content.addEventListener("transitionend", () => {
                this.transitioning = false;
                setTimeout(() => clearInterval(this.stickyInterval), 200);

                if(this.visible) {
                    if(this.preventOutsideFocus) {
                        this.controlFocus();
                    }
                    
                    //do scrolling behavior
                    if (this.scrollToElement) {
                        if (this.scrollToElement instanceof HTMLElement) {
                            this.$refs.content.scrollTo({ 
                                top: this.scrollToElement.offsetTop - 65, 
                                behavior: "smooth"
                            });
                            this.scrollToElement.focus();
                        }
                        this.scrollToElement = null;
                    }

                    this.$emit("shown");
                } else {
                    //Set the body back to normal if no sliders are visible
                    if(document.querySelector("." + defaultVisibleClass) === null) {
                        document.body.classList.remove(bodySliderOpenClass);
                    }

                    this.$emit("hidden");
                }
            });

            this.executeOnMount();
            this.$on('hide-slider', () => this.hide());
            this.$on('SetProp-PassEditClose', (data) => {
                this.goToPassEditOnClose = data
            });
            
        },
        computed: {
            inputs () {
                return this.$refs.container.querySelectorAll(focusableSelector);
            },
            firstInput() {
                return this.inputs[0];
            },
            lastInput () {
                return this.inputs[this.inputs.length - 1];
            },
            stickyOffset() {
                return {
                    top: this.top
                };
            },
            headerStyle() {
                return this.headerColor ? `background-color:${this.headerColor};` : "";
            },
            paddingString() {
                if(typeof this.padding !== "string") {
                    return this.padding + 'px';
                }
                return this.padding;
            },
            bodyPadding() {
                return this.paddingString + ' ' + this.paddingString + ' ' + ' 10px ' + this.paddingString;
            },
            mytop() {
                return this.isVerticalAlignment && !this.isMobileView() ? 14 : this.top;
            },
            mybottom() {
                return this.isVerticalAlignment && !this.isMobileView() ? 14 : this.bottom;
            },
            myLengthUnit() {
                return this.isVerticalAlignment && !this.isMobileView() ? '%' : 'px';
            },
            mySide() {
                var str = this.side;
                if(this.applyDDUpsellCustomStyle && !this.isMobileView()){
                    str += " dd-upsell-max-height"
                }
                return str;
            }
        },
        watch: {
            value(val) {
                if(this.visible !== val) {
                    this.visible = val;
                    this.toggle(val);
                }
            },
            canClose(val) {
                this.allowClose = val;
            }
        },
        methods: {

            SetGoToPassEditOnClose(propValue)
            {
                this.goToPassEditOnClose = propValue;
            },
            controlFocus() {
                let first = this.firstInput,
                    last = this.lastInput;

                if(!first) {
                    return;
                }

                first.addEventListener("keydown", e => {
                    if ((e.which === 9 && e.shiftKey)) {
                        e.preventDefault();
                        last.focus();
                    }
                });

                last.addEventListener("keydown", e => {
                    if ((e.which === 9 && !e.shiftKey)) {
                        e.preventDefault();
                        first.focus();
                    }
                });
            },
            //Show slider.  Optional parameter scrollTo will scroll to the specified element.  Accepts element or selector string 
            show(scrollTo) {
                if(scrollTo) {
                    if (typeof scrollTo === "string") {
                        this.scrollToElement = this.$refs.body.querySelector(scrollTo);
                    } else {
                        this.scrollToElement = scrollTo;
                    }
                }

                if(!this.isMounted) {
                    this.executeOnMount = () => {
                        this.show(scrollTo);
                    }
                    return;
                }

                if (this.returnFocus) {
                    //default the return to the header
                    this.activeElement = document.activeElement;
                }

                document.body.classList.add(bodySliderOpenClass);

                if(!this.visible) {
                    this.visible = true;
                }

                //need to force focus ring to show
                if(this.closeButton) {
                    forceTabBehavior();
                }

                //move focus to next stack
                if(this.canClose && this.closeButton) {
                    setTimeout(() => this.$refs.close.focus());
                } else if (this.firstInput) {
                    setTimeout(() => this.firstInput.focus());
                }

                this.$emit('input', this.visible);
                initializeCarousel();
                this.transitioning = true;
                this.stickyInterval = setInterval(initializeSticky, 10);
            },
            hide() {
                if(this.goToPassEditOnClose)
                {
                    var flightSelectForm = document.getElementById("flight-select-form");
                    if(flightSelectForm){
                        flightSelectForm.submit();
                    }
                }
                if(!this.allowClose) {
                    return;
                }

                if (this.returnFocus && this.activeElement) {
                    this.activeElement.focus();
                }

                if(this.visible) {
                    this.visible = false;
                }

                this.$emit('input', this.visible);
                this.transitioning = true;
                this.stickyInterval = setInterval(initializeSticky, 10);
            },
            forceHide() {
                var previousValue = this.allowClose;
                this.allowClose = true;
                this.hide();
                this.allowClose = previousValue;
            },
            toggle(show) {
                if(show) {
                    this.show();
                } else {
                    this.hide();
                }
            },
            isMobileView() {
                if (this.$mq === "mobile-lg" ||
                    this.$mq === "mobile" ||
                    this.$mq === "mobile-sm") {
                    return true;
                } else {
                    return false;
                }
            }
        },
        directives: {
            sticky
        }
    }

    function initializeSticky() {
        dispatchWindowEvent("touchstart");
    }
</script>

<template>
    <div ref="container" class="slider-container" :class="{ 'slider-visible': visible }" @keydown.esc="hide"
        role="dialog" aria-modal="true" :aria-expanded='visible' :style="{'z-index': zIndex }">
            <div ref="content" class="slider-content" :class="mySide" :style="'width:' + pixelWidth + 'px;' + side + ':' + offset + 'px; top:' + mytop + myLengthUnit + '; bottom:'+ mybottom + myLengthUnit + ';'">
                <div ref="header" v-sticky :sticky-offset="stickyOffset" class="slider-header" :class="{ offset: mytop > 0, twoLine: subTitle  }" :style="headerStyle">
                    <slot name="head"></slot>
                    <div class="slider-header-container">
                        <img v-if="headerImgSrc" :src="headerImgSrc" />
                        <div class="slider-header-title-container">
                            <template>
                                <span class="title" v-html="title"></span>
                                <span class="subTitle" v-if="subTitle" v-html="subTitle"></span>
                            </template>                          
                        </div>
                    </div>
                    <f9button nostyle v-if="canClose && closeButton" ref="close" @click="hide" class="close-icon" :class="{closeIconTop: subTitle}" aria-label="Close"></f9button>
                </div>
                <div ref="body" class="slider-body" :style="{ padding: bodyPadding }" :class="{'dd-upsell-height-auto': applyDDUpsellCustomStyle && !this.isMobileView()}">
                    <slot :show="show" :hide="hide" :visible="visible"></slot>
                </div>
            </div>
        <div @click="hide" class="slider-modal-top" :style="{ height: mytop + myLengthUnit }"></div>
        <div @click="hide" class="slider-modal" :style="{opacity: modalOpacity}"></div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    @transition-time: .6s;
    @header-font-size: 1em;
    @header-padding-left-right: 48px;
    @header-padding: 14px @header-padding-left-right 46px @header-padding-left-right;
    @header-padding-sm: 14px @header-padding-left-right 39px @header-padding-left-right;
    @body-padding: 40px 40px 10px 40px;

    .slider-container {
        /* height: 0; */

        &:not(.slider-visible) {
            .slider-body * {
                display:none;
            }
        }

        &.slider-visible {
            position: fixed;
            width: 100%;
            height: 100%;

            &>.slider-content {
                &.right {
                    right: 0px !important;
                }
                &.left {
                    left: 0px !important;
                }
            }

            &>.slider-modal,
            &>.slider-modal-top {
                display: block;
            }
        }

        .slider-content {
            position: fixed;
            right: 0;
            top: 0;
            bottom: 0;
            overflow-y: auto;
            transition: all @transition-time;
            z-index: 1010;
            background-color: @white;
            max-width: 98%;
            -webkit-overflow-scrolling: touch;

            &.dd-upsell-max-height{
                max-height: 645px;
            }

            .slider-body {
                padding: @body-padding;
                height: ~"calc(100% - 60px)";

                &.dd-upsell-height-auto{
                    height: auto;
                    padding: 0px 0px 0px !important;
                }

                @{deep} .signup-password-requirements {
                    max-height: initial;
                    margin-left: 24px;
                    padding: 16px 32px;
                    align-items: flex-start;
                    height: fit-content;
                    margin-top: 15px;
                }
            }

            .slider-header {
                display: flex;
                justify-content: space-between;
                height: 60px;
                align-items: center;
                color: @white;
                background-color: @frontier-green;
                transition: padding @transition-time;
                padding-left: 24px;
                padding-right: 24px;
                font-weight: 500;
                width: 100%;
                
                &.twoLine{
                    height: 122px;

                    .slider-header-title-container{
                        margin-top:1%;
                    }
                }

                .closeIconTop {
                    display: flex;
                    align-self: flex-start;
                    margin-top: 2%;
                }

                .slider-header-container{
                    display:flex;

                    img {
                        margin-left: 6%;
                        margin-right: 4%;
                        min-height: 74px;
                    }

                    .slider-header-title-container{
                        display: flex;
                        flex-direction: column;

                        .title{
                            text-transform: uppercase;
                            font-size: 24px;
                        }

                        .subTitle{
                            font-size: 32px;
                            margin-top: 1%;
                            line-height: normal;     
                            
                            
                        }  
                        .subTitle /deep/ .reg {
                                font-size: 10px;
                                vertical-align: super;
                        }                      
                    }
                }

                span {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                @{deep} a {
                    &:link, &:visited {
                        color: @white;
                    }
                }
                
                .close-icon {
                    cursor: pointer;
                    .cross(20px, 2px, @white);
                }
                
                /* This prevents the header from showing in the wrong place when scrolling and the top is offset. 
                if the sticky offset is fixed, this can go away. */
                &.offset.top-sticky {
                    top: 7.4% !important;
                }
            }
        }

        .slider-modal-top {
            display: none;
            opacity: 0;
            z-index: 1009;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
        }

        .slider-modal {
            display: none;
            background: rgb(0, 0, 0);
            z-index: 1009;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }

    @media screen and ( max-height: 900px ){

        .slider-container .slider-content .slider-body.dd-upsell-height-auto{
            height: ~"calc(100% - 122px)";
            overflow-y: auto;
        }
        .slider-container .slider-content.dd-upsell-max-height{
            overflow-y: initial;
        }
      
    }

    @media @tablet-lg {
        .slider-header {
            font-size: 18px;            
            height: 53px;
        }

        .slider-container .slider-content .slider-body {
            height: ~"calc(100% - 53px)";
        }
    }

    @media @tablet {
        .slider-container .slider-content .slider-body {
            padding: 21px;

            .slider-header {
                font-size: 18px;
            }

            @{deep} .signup-password-requirements {
                margin-left: 0;
            }
        }
    }

    @media @mobile-lg{

        .slider-container{
            .slider-content{
                 .slider-header {
                    &.twoLine{
                        height: 152px;

                        .slider-header-title-container{
                            margin-top:3%;
                        }
                    }

                    .closeIconTop {
                        display: flex;
                        align-self: flex-start;
                        margin-top: 3%;
                        width: 31px;
                        height: 31px;
                    }

                    .slider-header-container{
                        display:flex;

                        img {
                            margin-left: -2%;
                            margin-right: 2%;
                            width: 47px;
                            height: 47px;
                        }

                        .slider-header-title-container{
                            display: flex;
                            flex-direction: column;

                            .title{
                                text-transform: uppercase;
                                font-size: 18px;
                            }

                            .subTitle{
                                font-size: 24px;
                                line-height: normal;
                                white-space: normal;
                            }
                        }
                    }
                }
            }
        }   
    }

    @media @mobile-sm {
        .slider-container .slider-content .slider-body {
            padding: 10px 5px;
        }
    }

</style>